import { render, staticRenderFns } from "./JourneyStatisticsSankey.vue?vue&type=template&id=59fadbca&scoped=true&"
import script from "./JourneyStatisticsSankey.vue?vue&type=script&lang=js&"
export * from "./JourneyStatisticsSankey.vue?vue&type=script&lang=js&"
import style0 from "./JourneyStatisticsSankey.vue?vue&type=style&index=0&id=59fadbca&scoped=true&lang=scss&"
import style1 from "./JourneyStatisticsSankey.vue?vue&type=style&index=1&id=59fadbca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fadbca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59fadbca')) {
      api.createRecord('59fadbca', component.options)
    } else {
      api.reload('59fadbca', component.options)
    }
    module.hot.accept("./JourneyStatisticsSankey.vue?vue&type=template&id=59fadbca&scoped=true&", function () {
      api.rerender('59fadbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/JourneyStatisticsSankey.vue"
export default component.exports